/**
 * Import constants
 */
import { GET_API_KEY_DATA, GET_API_KEY_DATA_PENDDING, GET_API_KEY_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: [],
	error: null
};

/**
 * API key reducer
 * @param {*} state
 * @param {*} action
 */
export const apiKeysReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_API_KEY_DATA_PENDDING:
			return {
				...state,
				loading: true
			};
		case GET_API_KEY_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_API_KEY_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
